import { render, staticRenderFns } from "./Informative.vue?vue&type=template&id=4c3499b1&scoped=true"
import script from "./Informative.vue?vue&type=script&lang=js"
export * from "./Informative.vue?vue&type=script&lang=js"
import style0 from "./Informative.vue?vue&type=style&index=0&id=4c3499b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3499b1",
  null
  
)

export default component.exports